var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlocateLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.46,
    height: 20.29,
    viewBox: "0 0 19.46 20.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#479ed5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(371.507 -4531.416)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-370.107,4534.169a1.354,1.354,0,0,1,1.352-1.353h4.256v-1.4h-4.256a2.755,2.755,0,0,0-2.752,2.753v4.257h1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-370.107,4548.953V4544.7h-1.4v4.257a2.755,2.755,0,0,0,2.752,2.753h4.256v-1.4h-4.256A1.354,1.354,0,0,1-370.107,4548.953Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-353.448,4548.953a1.353,1.353,0,0,1-1.351,1.353h-4.257v1.4h4.257a2.756,2.756,0,0,0,2.752-2.753V4544.7h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-354.8,4531.416h-4.257v1.4h4.257a1.353,1.353,0,0,1,1.351,1.353v4.257h1.4v-4.257A2.756,2.756,0,0,0-354.8,4531.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-358.706,4538.585a.687.687,0,0,0-.968.088l-2.955,3.546-1.531-1.53a.688.688,0,0,0-.972,0,.688.688,0,0,0,0,.972l2.063,2.063a.687.687,0,0,0,.486.2h.031a.686.686,0,0,0,.5-.247l3.438-4.125A.687.687,0,0,0-358.706,4538.585Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlocateLocker);
export default __webpack_public_path__ + "static/media/alocateLocker.c22adb73a25b702efccf23babacc100d.svg";
export { ForwardRef as ReactComponent };